import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "q-mt-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_chip = _resolveComponent("q-chip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
        (item.avatarText > 0 || item.key == 'no_of_coupon_zones')
          ? (_openBlock(), _createBlock(_component_q_chip, {
              key: 0,
              square: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_avatar, {
                  color: _ctx.color(item),
                  "text-color": _ctx.textColor(item)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.avatarText), 1)
                  ]),
                  _: 2
                }, 1032, ["color", "text-color"]),
                _createTextVNode(" " + _toDisplayString(item.label), 1)
              ]),
              _: 2
            }, 1024))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}